import React from 'react';
import StoryLayout from '../components/StoryLayout';
import storyData from '../story.json';

const StoryFirstYear = () => {
  return (
    <StoryLayout
      storyData={storyData}
      title="Az első csata"
      date="2025. május 9."
    />
  );
};

export default StoryFirstYear;
